import React from 'react';

import {Button, Icon} from '@albert-io/atomic';

import withTracking from 'lib/hocs/withTracking';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import GoogleSignInButton from 'client/components/Google/GoogleSignInButton/GoogleSignInButton.react';
import {
  GOOGLE_CLASSROOM_ASSIGNMENTS_FLAG,
  startGoogleClassroomConsent
} from 'client/components/Google/googleClassroomConsent';
import {useGoogleClassroomConnection} from 'client/components/Google/useGoogleClassroomConnection';

const TrackedButton = withTracking(Button, {
  onClick: {event: 'click', content: 'Sign into Google'}
});

/**
 * Google sign-in for the classroom importer. With the assignments flag on, a teacher the backend
 * does not hold a working Google Classroom connection for goes through the offline-consent flow
 * (which stores the refresh token grade passback needs); a connected teacher, and everyone with
 * the flag off, gets the standard popup sign-in.
 */
const GoogleClassroomSignInButton = () => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(GOOGLE_CLASSROOM_ASSIGNMENTS_FLAG);
  const connection = useGoogleClassroomConnection({skip: isLoading || !isFeatureEnabled});

  // An unanswered connection query (failed, say) still offers the connect flow: that is the safe
  // default, since a connected teacher can simply complete it again.
  const isResolving = isLoading || connection.isLoading;

  if (isResolving || (isFeatureEnabled && !connection.isConnected)) {
    return (
      <TrackedButton
        aria-label='Sign into Google'
        data-testid='google-classroom-consent-sign-in-button'
        disabled={isResolving}
        onClick={() => startGoogleClassroomConsent()}
      >
        <Icon icon={['fab', 'google']} className='mr-x1' />
        Sign into Google
      </TrackedButton>
    );
  }

  return <GoogleSignInButton isButton />;
};

export default GoogleClassroomSignInButton;
